/**
 * <s-countdown> — live countdown to the `end` attribute (epoch ms).
 * Updates [data-unit-value] spans every second and toggles the days chip.
 * With `hide-when-ended`, removes the bar once the time has passed.
 */
class SCountdown extends HTMLElement {
  #timer = null;

  connectedCallback() {
    this.end = Number(this.getAttribute('end')) || 0;
    this.days = this.querySelector('[data-unit="days"]');
    this.daysValue = this.days?.querySelector('[data-value]');
    this.values = {};
    this.querySelectorAll('[data-unit-value]').forEach((el) => {
      this.values[el.dataset.unitValue] = el;
    });
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const remaining = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
    if (remaining === 0) {
      clearInterval(this.#timer);
      if (this.hasAttribute('hide-when-ended')) {
        this.hidden = true;
        return;
      }
    }
    const pad = (n) => String(n).padStart(2, '0');
    const d = Math.floor(remaining / 86400);
    if (this.days) {
      this.days.hidden = d === 0;
      if (this.daysValue) this.daysValue.textContent = String(d);
    }
    if (this.values.hours) this.values.hours.textContent = pad(Math.floor((remaining % 86400) / 3600));
    if (this.values.minutes) this.values.minutes.textContent = pad(Math.floor((remaining % 3600) / 60));
    if (this.values.seconds) this.values.seconds.textContent = pad(remaining % 60);
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
